import React from 'react'
import { LanguageConstants } from '../constants/LanguageConstants'
import { formatDisplayLongDate } from '../utils/Helper'

function MessageHistoryModal(props: any) {
  const rows = Array.isArray(props?.rows) ? props.rows : []
  const hidePartNumber = props?.hidePartNumber === true
  const colSpan = hidePartNumber ? 3 : 4
  const idLabel = props?.titleLabel ?? LanguageConstants?.QUOTATIONID
  const displayId =
    props?.titleId ??
    props?.quotationId ??
    props?.data?.uuid ??
    props?.data?.quotation_id
  const onClose = () => props?.onClose?.() ?? props?.setHistoryshow?.(false)

  return (
    <>
     <div className="modal fade com-modal modal view-message-history-modal show" id="viewMessageHistoryModal" aria-labelledby="viewMessageHistoryModalLabel" aria-hidden="false" style={{ display: 'block' }} >
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="viewMessageHistoryModalLabel">{idLabel} : {displayId}</h5>
                            <button type="button" onClick={onClose} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close" /></button>
                        </div>
                        <div className="modal-body">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th className="text-center">{LanguageConstants?.Item}</th>
                                            <th className="text-start">{LanguageConstants?.DATE}</th>
                                            {!hidePartNumber ? (
                                              <th className="text-start">{LanguageConstants?.PARTNAMEFULL}</th>
                                            ) : null}
                                            <th className="text-start" style={{minWidth: '260px'}}>{LanguageConstants?.MESSAGE}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.length > 0 ? rows.map((res: any, i: any) => (
                                            <tr key={i}>
                                              <td className="text-center">{res?.item ? res?.item : '---'}</td>
                                              <td className="text-start text-nowrap">{formatDisplayLongDate(res?.created_at, '---')}</td>
                                              {!hidePartNumber ? (
                                                <td className="text-start">{res?.part_number ? res?.part_number : ''}</td>
                                              ) : null}
                                              <td className="text-start">{res?.message ? res?.message : ''}</td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={colSpan} className="text-center py-4 text-muted">
                                                    {LanguageConstants?.NO_REQUEST_FOUND ?? 'No request found.'}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </>
  )
}


export default MessageHistoryModal